import type * as z from "zod";
import { envSchema } from "./env.schema";

const bootSchema = envSchema.omit({
  VITE_LOG_BACKEND: true,
  VITE_LOG_DEBUG: true,
  VITE_APP_VERSION: true,
});

// `X=` in .env.local defers the decision rather than making one, the same
// rule as @bindery/shared/env's envReader.
function bootSource(): Record<string, unknown> {
  const raw = import.meta.env as Record<string, unknown>;
  const source: Record<string, unknown> = {};
  for (const name of Object.keys(bootSchema.shape)) {
    const value = raw[name];
    if (value !== undefined && value !== "") source[name] = value;
  }
  return source;
}

function describeFailure(source: Record<string, unknown>): string {
  return Object.entries(bootSchema.shape)
    .flatMap(([name, field]) => {
      const parsed = field.safeParse(source[name]);
      if (parsed.success) return [];
      if (source[name] === undefined) return [`${name} is not set`];
      const issues = parsed.error.issues.map((issue) => issue.message);
      return [`${name} is invalid (${issues.join("; ")})`];
    })
    .join("; ");
}

export const env: z.infer<typeof bootSchema> = (() => {
  const source = bootSource();
  const result = bootSchema.safeParse(source);
  if (result.success) return result.data;
  const described = describeFailure(source);
  throw new Error(described === "" ? result.error.message : described);
})();
